import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import Looks3Icon from '@mui/icons-material/Looks3'
import LooksOneIcon from '@mui/icons-material/LooksOne'
import LooksTwoIcon from '@mui/icons-material/LooksTwo'
import SecurityIcon from '@mui/icons-material/Security'
import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Typography from '@mui/material/Typography'
import {blue, blueGrey, grey, red} from '@mui/material/colors'
import ProgressDialog from 'app/components/dialogs/ProgressDialog'
import toastr from 'toastr'
// import BasicInfoForm from 'app/pages/profileWizard/components/BasicInfoForm'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import Divider from '@mui/material/Divider'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import TimerComponent from 'app/components/timer'

import {UserRepo} from 'app/hooks/api_repos'
import {useOnActionPost} from 'app/hooks/common/useOnActionPost'
import {useAppNavigate} from 'app/hooks/navigation/useAppNavigate'
import {useAcceptProjectInvitation} from 'app/hooks/subscription/useAcceptProjectInvitation'
import {useAcceptTenantInvitation} from 'app/hooks/subscription/useAcceptTenantInvitation'
import {useRejectProjectInvitation} from 'app/hooks/subscription/useRejectProjectInvitation'
import {useRejectTenantInvitation} from 'app/hooks/subscription/useRejectTenantInvitation'
import {useAuthProvider} from 'app/modules/auth'
import CognitoState from 'app/modules/cognito/core/_state'
import CognitoUrls from 'app/modules/cognito/core/_urls'
import CognitoUser from 'app/modules/cognito/core/_user'
import {IProjectInvitation} from 'interfaces/IProjectInvitation'
import {ITenantInvitation} from 'interfaces/ITenantInvitation'
import {DateTime} from 'luxon'
import React from 'react'
import {Link as RouterLink, useSearchParams} from 'react-router-dom'
import {emGetActiveTenantData} from 'utilities/emUserFeatures'
import {emSleep} from 'utilities/extensionMethods'
import BasicInfoForm from '../../signup/SignupModal/BasicInfoForm'
import {InviteUserSteps, TOTAL_STEPS, useInviteProvider} from './InviteContextProvider'

// use by public route /invite and by private route teninvitation
// step 1 is welcome, step 2 is create the user, await cognitio login, and redirect to /teninvitation for step 3. to accept invitation
export default function Invite({loggedIn}: {loggedIn?: boolean}) {
  const createUser = useOnActionPost()
  const [searchParams] = useSearchParams()
  const {reduxUser} = useAuthProvider()
  const chk = UserRepo

  const {
    setModalOpen,
    step,
    setStep,
    goToNextStep,
    goToPrevStep,
    modalOpen,
    starterInfo,
    setStarterData,
  } = useInviteProvider()
  const [awaitingLogin, setAwaitingLogin] = React.useState<boolean>(false)
  const submitButtonRef = React.useRef<HTMLButtonElement>(null)
  const navigate = useAppNavigate()
  const execAcceptTenantInvitation = useAcceptTenantInvitation()
  const execRejectTenantInvitaion = useRejectTenantInvitation()
  const execAcceptProjectInvitation = useAcceptProjectInvitation()
  const execRejectProjectInvitation = useRejectProjectInvitation()

  const close = () => {
    navigate('/')
  }

  const handleLogin = () => {
    alert(JSON.stringify(CognitoUrls.login))
    window.location.href = CognitoUrls.login
    window.location.reload()
  }
  async function handleSubmit(data: any) {
    const si = {
      email: data.email,
      last_name: data.lastName ?? '',
      first_name: data.firstName ?? '',
    }
    setStarterData(si)
    //create the user
    const result: any = await createUser.mutateAsync({
      data: si,
      route: `std/user`,
    })

    result
      ? toastr.success('Successfully created account, awaiting login now')
      : toastr.error('An error occurred creating the user account.')
    setStep(InviteUserSteps.AwaitLogin)
    //memoized function will await on this step before rdireting user to cognito
  }
  const memoAwaitingStep = React.useMemo(async () => {
    if (step === InviteUserSteps.AwaitLogin) {
      await emSleep(6000)
      const url = new URL(window.location.origin)
      CognitoState.create()
      CognitoUrls.storeIscoutDestination(url.pathname + 'dashboard/home')
      window.location.replace(CognitoUrls.login)
      // emSleep(6000)
      setAwaitingLogin(true)
      return {user: CognitoUser, redirect: true}
    }
  }, [step])

  React.useEffect(() => {
    //we only set the step to accept an invitation when there are open invitations, else we go home
    if (
      loggedIn &&
      (reduxUser?.tenant_invitations_received as unknown as ITenantInvitation[])?.find(
        (tenInv) => tenInv.is_open
      )
    ) {
      //looged in with an open invitation to accept or decline
      setStep(InviteUserSteps.FindTenant)
    }
    if (
      loggedIn &&
      (reduxUser?.project_invitations_received as unknown as IProjectInvitation[])?.find(
        (projInv) => projInv.is_open
      )
    ) {
      //looged in with an open invitation to accept or decline
      setStep(InviteUserSteps.ProjectInvitation)
    }
    //close modal if no open invitations
    if (
      loggedIn &&
      !(reduxUser?.tenant_invitations_received as unknown as ITenantInvitation[])?.find(
        (tenInv) => tenInv.is_open
      ) &&
      !(reduxUser?.project_invitations_received as unknown as IProjectInvitation[])?.find(
        (tenInv) => tenInv.is_open
      )
    ) {
      //logged in with no open invitations
      //close the modal
      setModalOpen(false)
    }
  }, [step, reduxUser])

  const handleAcceptTenantInvitation = async (id: string, accepting_tenant_id: string) => {
    const res = await execAcceptTenantInvitation.mutateAsync({
      tenant_invitation_id: id,
      accepting_tenant_id: accepting_tenant_id,
    })
    if (res === null) {
      toastr.success('Invitation acepted')
    } else {
      toastr.error('Error accepting invitation')
    }
    setModalOpen(false)
    window.location.reload()
  }
  const handleRejectTenantInvitation = async (id: string, accepting_tenant_id: string) => {
    const res = await execRejectTenantInvitaion.mutateAsync({
      tenant_invitation_id: id,
      accepting_tenant_id: accepting_tenant_id,
    })
    if (res === null) {
      toastr.success('Invitation declined')
    } else {
      toastr.error('Error declining invitation')
    }
    setModalOpen(false)
    window.location.reload()
  }

  const handleAcceptProjectInvitation = async (project_invitation: IProjectInvitation) => {
    const res = await execAcceptProjectInvitation.mutateAsync({
      project_invitation: project_invitation,
    })
    if (res === null) {
      toastr.success('Invitation acepted')
    } else {
      toastr.error('Error accepting invitation')
    }
    setModalOpen(false)
    window.location.reload()
  }
  const handleRejectProjectInvitation = async (project_invitation: IProjectInvitation) => {
    const res = await execRejectProjectInvitation.mutateAsync({
      project_invitation: project_invitation,
    })
    if (res === null) {
      toastr.success('Invitation declined')
    } else {
      toastr.error('Error declining invitation')
    }
    setModalOpen(false)
    window.location.reload()
  }

  const content:
    | {node: React.ReactNode; title: string | React.ReactNode; subTitle: string | React.ReactNode}
    | undefined = React.useMemo(() => {
    if (step === InviteUserSteps.Welcome) {
      return {
        node: (
          <>
            <DialogContent>
              <Typography variant={'h5'} m={1} mt={0} mb={1} fontWeight={500} color={grey[700]}>
                Click continue to get started:
              </Typography>
            </DialogContent>
            <DialogActions sx={{display: 'flex', bgcolor: grey[200]}}>
              <Button to='/' component={RouterLink} variant='text'>
                Cancel
              </Button>
              <Button onClick={goToNextStep} variant='contained' color='primary' size='large'>
                Continue
              </Button>
            </DialogActions>
          </>
        ),
        title: <DialogTitle fontWeight={700}>Welcome to iScout</DialogTitle>,
        subTitle: (
          <Box>
            <Box display={'flex'} gap={1}>
              <Typography variant={'h5'} m={3} mb={1} fontWeight={500} color={grey[700]}>
                You've been invited to iScout. If you already have an iScout account, you can login
                to accept your invitation; If not, to get started, we'll need to complete the next
                few steps if you do not already have an account:
              </Typography>
              <Box m={2}>
                <Button
                  size='small'
                  variant={'contained'}
                  onClick={() => {
                    CognitoState.create()
                    window.location.href = CognitoUrls.login
                  }}
                  color='primary'
                  sx={{fontSize: '1em', fontWeight: 600}}
                >
                  I already have an acount
                </Button>
              </Box>
            </Box>
            <List
              sx={{width: '100%', maxWidth: 700, bgcolor: 'background.paper', pl: 3}}
              aria-label='contacts'
            >
              <ListItem disablePadding>
                <ListItemButton sx={{fontSize: '24px'}}>
                  <ListItemIcon>
                    <LooksOneIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary='Collect your basic info'
                    sx={{'& span': {fontSize: '1.5rem'}}}
                  />
                </ListItemButton>
              </ListItem>
              <ListItem disablePadding>
                <ListItemButton>
                  <ListItemIcon>
                    <LooksTwoIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary='Login using one-time credentials emailed to you'
                    sx={{'& span': {fontSize: '1.5rem'}}}
                  />
                </ListItemButton>
              </ListItem>
              <ListItem disablePadding>
                <ListItemButton>
                  <ListItemIcon>
                    <Looks3Icon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Once logged in, you'll be promted to join the tenant that invited you"
                    sx={{'& span': {fontSize: '1.5rem'}}}
                  />
                </ListItemButton>
              </ListItem>
            </List>
          </Box>
        ),
      }
    }
    if (step === InviteUserSteps.EnterBasicInfo) {
      return {
        node: (
          <>
            <DialogContent>
              {awaitingLogin ? (
                <Box>
                  <Typography variant={'h4'} color={grey[800]}>
                    <SecurityIcon fontSize={'medium'} color={'warning'} />
                    Redirecting to AWS Login
                  </Typography>
                  <Typography variant={'h6'} color={grey[600]}>
                    Please Check your email for your login credentials
                  </Typography>
                </Box>
              ) : (
                <BasicInfoForm
                  loading={false}
                  submitButtonProps={{style: {display: 'none'}}}
                  submitButtonRef={submitButtonRef}
                  goToNextStep={goToNextStep}
                  initialValues={starterInfo}
                  onSubmit={handleSubmit}
                />
              )}
            </DialogContent>
            <DialogActions
              sx={{display: 'flex', justifyContent: 'space-between', bgcolor: grey[200]}}
            >
              <Box>
                <Button onClick={goToPrevStep}>
                  <ArrowBackIcon sx={{mr: 1}} />
                  Go Back
                </Button>
              </Box>
              <Box>
                <Button to='/' component={RouterLink} variant='text'>
                  Cancel
                </Button>

                <Button
                  disabled={false}
                  onClick={() => submitButtonRef.current?.click()}
                  variant='contained'
                  color='primary'
                  size='large'
                >
                  Sign Up
                </Button>
              </Box>
            </DialogActions>
          </>
        ),
        title: <DialogTitle fontWeight={700}>Sign Up</DialogTitle>,
        subTitle: (
          <Typography variant={'h6'} m={3} mb={1} fontWeight={500} color={grey[600]}>
            Provide the following information to Sign up
          </Typography>
        ),
      }
    }
    if (step === InviteUserSteps.AwaitLogin) {
      return {
        node: (
          <>
            <DialogContent>
              <Box
                display={'flex'}
                justifyContent={'center'}
                textAlign={'center'}
                alignItems={'center'}
                minHeight={'250px'}
              >
                <Box
                  display={'flex'}
                  flexDirection={'column'}
                  alignContent={'center'}
                  textAlign={'center'}
                  alignItems={'center'}
                  gap={2}
                >
                  <Typography variant={'h4'} color={grey[600]} mt={5}>
                    Awating Login, check your email for credentials
                  </Typography>
                  <Typography variant={'h5'} m={1} mt={0} mb={1} fontWeight={500} color={red[700]}>
                    Page will automatically redirect to AWS login in:
                  </Typography>
                  <TimerComponent hideReset={true} secondsUntilZero={6} />
                  <Divider />
                  <CircularProgress size={25} />
                </Box>
              </Box>
            </DialogContent>
            <DialogActions sx={{display: 'flex', bgcolor: grey[200]}}></DialogActions>
          </>
        ),
        title: <DialogTitle fontWeight={700}>Awaiting Login</DialogTitle>,
        subTitle: (
          <Box>
            <Typography variant={'h5'} m={3} mb={1} fontWeight={500} color={grey[700]}>
              Account creation in progress...
            </Typography>
          </Box>
        ),
      }
    }
    if (step === InviteUserSteps.FindTenant) {
      return {
        node: (
          <>
            <DialogContent>
              {(reduxUser?.tenant_invitations_received as unknown as ITenantInvitation[])?.map(
                (tenInv: ITenantInvitation, i: number) => {
                  console.log(JSON.stringify(tenInv))
                  return (
                    <Box m={1} mt={0} p={1} pt={0} bgcolor={'#FFFFFF'}>
                      <Box mb={3} display={'flex'} gap={1}>
                        <Typography variant={'h5'} color={blueGrey[600]} fontWeight={400}>
                          You've received an invitation to join:
                        </Typography>
                        <Typography variant={'h5'} color={blue[700]} fontWeight={600}>
                          {tenInv.sender_tenant_name ?? 'a tenant'}
                        </Typography>
                      </Box>
                      <Divider />
                      <Box
                        display={'flex'}
                        alignItems={'center'}
                        justifyContent={'space-between'}
                        mb={1}
                      >
                        <Typography variant={'h6'} color={grey[800]}>
                          Sent from: {tenInv.sender_user_name}
                        </Typography>
                        <Typography variant={'h6'} color={grey[700]}>
                          Invite created on:{' '}
                          {DateTime.fromISO(tenInv?.created?.at ?? '').toLocaleString(
                            DateTime.DATETIME_SHORT
                          )}
                        </Typography>
                      </Box>
                      <Divider />
                      <Box>
                        <Typography variant={'h6'} color={grey[600]}>
                          message: {tenInv.message ?? 'Please join our iScout tenancy'}
                        </Typography>
                      </Box>
                      <Divider />
                      <Box display={'flex'} gap={5} justifyContent={'flex-end'} mt={4}>
                        <Button
                          onClick={() =>
                            handleRejectTenantInvitation(
                              tenInv.id,
                              reduxUser ? emGetActiveTenantData(reduxUser)?.id ?? '' : ''
                            )
                          }
                          color={'inherit'}
                          variant={'outlined'}
                        >
                          Decline
                        </Button>
                        <Button
                          onClick={() =>
                            handleAcceptTenantInvitation(
                              tenInv.id,
                              reduxUser ? emGetActiveTenantData(reduxUser)?.id ?? '' : ''
                            )
                          }
                          variant={'contained'}
                        >
                          Accept
                        </Button>
                      </Box>
                    </Box>
                  )
                }
              )}
            </DialogContent>
            <DialogActions sx={{display: 'flex', bgcolor: grey[200]}}>
              <Button to='/' component={RouterLink} variant='text'>
                Cancel
              </Button>
            </DialogActions>
          </>
        ),
        title: <DialogTitle fontWeight={700}>Tenant Invitation</DialogTitle>,
        subTitle: <></>,
      }
    }
    if (step === InviteUserSteps.ProjectInvitation) {
      return {
        node: (
          <>
            <DialogContent>
              {(reduxUser?.project_invitations_received as unknown as IProjectInvitation[])?.map(
                (projInv: IProjectInvitation, i: number) => {
                  return (
                    <Box m={1} mt={0} p={1} pt={0} bgcolor={'#FFFFFF'}>
                      <Box mb={3} display={'flex'} gap={1}>
                        <Typography variant={'h5'} color={blueGrey[600]} fontWeight={400}>
                          You've received an invitation to join a project from:
                        </Typography>
                        <Typography variant={'h5'} color={blue[700]} fontWeight={600}>
                          Tenant: {projInv.sender_tenant_name}
                        </Typography>
                      </Box>
                      <Divider />
                      <Box
                        display={'flex'}
                        alignItems={'center'}
                        justifyContent={'space-between'}
                        mb={1}
                      >
                        <Typography variant={'h6'} color={grey[800]}>
                          Invited By: {projInv.sender_user_name}
                        </Typography>
                        <Typography variant={'h6'} color={grey[700]}>
                          Project Invite created on:{' '}
                          {DateTime.fromISO(projInv?.created?.at ?? '').toLocaleString(
                            DateTime.DATETIME_SHORT
                          )}
                        </Typography>
                      </Box>
                      <Divider />
                      <Box>
                        <Typography variant={'h6'} color={grey[600]}>
                          message: {projInv.message ?? 'Please join our Project'}
                        </Typography>
                      </Box>
                      <Divider />
                      <Box display={'flex'} gap={5} justifyContent={'flex-end'} mt={4}>
                        <Button
                          onClick={() => handleRejectProjectInvitation(projInv)}
                          color={'inherit'}
                          variant={'outlined'}
                        >
                          Decline
                        </Button>
                        <Button
                          onClick={() => handleAcceptProjectInvitation(projInv)}
                          variant={'contained'}
                        >
                          Accept
                        </Button>
                      </Box>
                    </Box>
                  )
                }
              )}
            </DialogContent>
            <DialogActions sx={{display: 'flex', bgcolor: grey[200]}}>
              <Button to='/' component={RouterLink} variant='text'>
                Cancel
              </Button>
            </DialogActions>
          </>
        ),
        title: <DialogTitle fontWeight={700}>Project Invitation</DialogTitle>,
        subTitle: <></>,
      }
    }
  }, [step, goToNextStep, awaitingLogin])
  return (
    <ProgressDialog
      open={modalOpen}
      onClose={() => setModalOpen(false)}
      totalSteps={TOTAL_STEPS}
      step={step}
      maxWidth='md'
      title={content?.title}
      subTitle={content?.subTitle}
    >
      {content?.node}
    </ProgressDialog>
  )
}
